import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UseCase } from '@digibricks/domains';
import { AudioPlayStats } from '../../../../domain';
export var UPDATE_EXAMINATION_SUBMISSION_USE_CASE = 'UPDATE_EXAMINATION_SUBMISSION_USE_CASE';
export var UpdateExaminationSubmissionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateExaminationSubmissionUseCase, _UseCase);

  var _super = _createSuper(UpdateExaminationSubmissionUseCase);

  function UpdateExaminationSubmissionUseCase(examinationSubmissionRepository) {
    var _this;

    _classCallCheck(this, UpdateExaminationSubmissionUseCase);

    _this = _super.call(this);
    _this.examinationSubmissionRepository = examinationSubmissionRepository;
    return _this;
  }

  _createClass(UpdateExaminationSubmissionUseCase, [{
    key: "validate",
    value: function validate(useCaseInput) {
      var id = useCaseInput.id;
      var collection = [{
        argument: id,
        argumentName: 'Submission Id'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var submission, input, resultOrError, response, submissionAudioPlayStatsList, audioFileId, existingAudioPlayStats, updatedNumberOfReplays, updatedAudioPlayStats, newAudioPlayStatsList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                submission = useCaseInput.submission, input = useCaseInput.input;
                resultOrError = this.validate(useCaseInput);

                if (!resultOrError.isFailure) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 4:
                _context.next = 6;
                return this.examinationSubmissionRepository.update(useCaseInput);

              case 6:
                response = _context.sent;

                if (!response.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", response);

              case 9:
                if (input !== null && input !== void 0 && input.audioPlayStats) {
                  submissionAudioPlayStatsList = submission.audioPlayStats;
                  audioFileId = input.audioPlayStats.audioFileId;
                  existingAudioPlayStats = submissionAudioPlayStatsList.find(function (stats) {
                    return stats.audioFileId === audioFileId;
                  });
                  updatedNumberOfReplays = (existingAudioPlayStats === null || existingAudioPlayStats === void 0 ? void 0 : existingAudioPlayStats.numberOfReplays) !== undefined ? existingAudioPlayStats.numberOfReplays + 1 : 0;
                  updatedAudioPlayStats = AudioPlayStats.create({
                    audioFileId: audioFileId,
                    numberOfReplays: updatedNumberOfReplays,
                    hasPlayed: true
                  }).getValue();
                  newAudioPlayStatsList = existingAudioPlayStats ? submissionAudioPlayStatsList.map(function (stats) {
                    return stats.audioFileId === audioFileId ? updatedAudioPlayStats : stats;
                  }) : [].concat(_toConsumableArray(submissionAudioPlayStatsList), [updatedAudioPlayStats]);
                  submission.updateAudioPlayStats(newAudioPlayStatsList);
                }

                return _context.abrupt("return", Result.ok());

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateExaminationSubmissionUseCase;
}(UseCase);